import axios from 'axios'
import storage from '@/modules/storage'
import {
  clone,
  isObject,
} from 'lodash'
import Promise from 'bluebird'
const ignoredPaths = ['/login']
axios.defaults.baseURL = process.env.baseURL
axios.defaults.timeout = 15000

const stripTailingSlash = url => {
  return url.replace(/\/+$/g, '')
}


const removeDateAttr = data => {
  if (data && (data.createdAt || data.updateAt)) {
    delete data.createdAt
    delete data.updatedAt
  }
  return data
}

export default class Http {
  constructor ({ modelUrlPrefix, timeout, apiVersion = '/api/v2/' }) {
    this.client = axios.create({
      baseURL : stripTailingSlash(process.env.VUE_APP_API_URL) + apiVersion +
                stripTailingSlash(modelUrlPrefix),
      timeout,
      modelUrlPrefix
    })

    this.client.interceptors.request.use(this.embedToken)
    this.client.interceptors.response
      .use(response => response, this.authenticateUser)
  }

  authenticateUser (error) {
    if (!error.response) {
      error.response = { data : 'No response from backend server, ' +
        'please check your internet connection and try again later' }
    } else if (error.response.status === 401) {
      storage.removeAll()
      // window.location.href = '/user/login'
    }

    return Promise.reject(error)
  }

  embedToken (config) {
    if(!ignoredPaths.includes(config.url)) {
      const accessToken = storage.get('accessToken')
      config.headers['x-access-token'] = accessToken
    }

    return config
  }

  get (id) {
    if (!id) {
      throw new Error('Id is required parameter')
    }
    return this.client.get(id)
  }


  
  create (param = null, data) {
    if (isObject(param)) {
      data = clone(param)
      param = null
    } else if (!isObject(data)) {
      data = {}
    }
    return this.client.post(param, removeDateAttr(data))
  }

  update (id, data) {
    return this.client.put(id.toString(), removeDateAttr(data))
  }

  patch (id, data) {
    return this.client.patch(id.toString(), removeDateAttr(data))
  }

  destroy (id, options = {}) {
    return this.client.delete(id.toString(), options)
  }

  upload (data) {
    return this.client.post(`upload`, data)
  }
}
